import tempInvestFilterRules from '../config/tmp_invest_filter_rules.json'
import filtersAPI from '../api/filters'

export default {
  data()
  {
    return {
      filterRules: tempInvestFilterRules,
      customFilters: [],
      customFiltersStatuses: [],
      enabledCustomFilter: null,
      enabledFilters: [],
      customFilter: this.$store.getters['filters/customFilter'],
      showFilters: []
    }
  },
  computed: {
    isLoaded: function ()
    {
      return !!this.$store.state.filters.filters
    }
  },
  created()
  {
    this.$root.$on('resetInvestFilters', () =>
    {
      this.customFiltersStatuses = []
      this.enabledCustomFilter = null
    })
  },
  mounted()
  {
    if (this.$store.state.filters.filters)
    {
      this.showFilters = this.$store.getters['filters/getListOfFilters'](this.$router.currentRoute.path)
      this.customFilters.user_filters = this.$store.state.filters.filters.user_filters
      this.customFilters.popular_filters = this.$store.state.filters.filters.popular_filters
    }
    else
    {
      this.$watch(() =>
      {
        return this.$store.state.filters.filters
      }, (newFilters) =>
      {
        if (newFilters)
        {
          this.showFilters = this.$store.getters['filters/getListOfFilters'](this.$router.currentRoute.path)
        }
      })
    }
  },
  methods: {
    filterItems(items)
    {
      return items
    },
    setFilter(filter)
    {
      const newFilter = {id: filter.id, values: filter.values}
      const filterIndex = this.enabledFilters.findIndex(x => x.id === filter.id)

      // For single select-list values
      if (typeof filter.values === 'object' && filter.values !== null && !Array.isArray(filter.values) && !filter.values.values)
      {
        filter.values = [filter.values]
        newFilter.values = filter.values
      }
      // For multi select-list bugfix
      if (filter.values && typeof filter.values === 'object' && filter.values.values && (typeof filter.values.values === 'object' || typeof filter.values.values === 'string'))
      {
        filter.values = filter.values.values
        newFilter.values = filter.values
      }
      // Disable duplicates of filters
      if (filterIndex === -1)
      {
        if (
          ((Array.isArray(filter.values) || typeof filter.values === 'string') && filter.values.length > 0) ||
          (typeof filter.values === 'boolean')
        )
        {
          this.enabledFilters.push(newFilter)
        }
      }
      else
      {
        // Structure changed on BE. This fix for situation when user set custom filter twice and more
        if (filter.values && filter.values.values && filter.values.values.length)
        {
          filter.values = filter.values.values
        }
        if (!filter.values || (filter.values && filter.values.length === 0))
        {
          this.enabledFilters.splice(filterIndex, 1)
          // console.log('splice')
        }
        else
        {
          if (this.enabledFilters[filterIndex].values !== filter.values)
          {
            this.enabledFilters[filterIndex].values = filter.values
          }
        }
      }
      this.$store.dispatch('filters/updateEnabledFilters', this.enabledFilters)
    },
    setEnabledFilters(filters)
    {
      this.enabledFilters = filters
      this.$store.dispatch('filters/updateEnabledFilters', this.enabledFilters)
    },
    setCustomFilter(customFilter)
    {
      // Already active -> deactivation
      if (this.enabledCustomFilter === customFilter.id)
      {
        this.clearCustomFilter(customFilter)
      } else {
        this.$store.dispatch('filters/updateSendRequest', true)
        this.setDefaultValues()
        this.$store.dispatch('filters/updateSendRequest', false)
        this.$root.$emit('resetLockRequest')
        this.customFiltersStatuses = [customFilter.id]
        this.enabledCustomFilter = customFilter.id
        this.$store.dispatch('filters/updateEnabledCustomFilters', customFilter)
      }
    },
    deleteFilter(customFilterId)
    {
      const filterSection = this.$refs['user_filter_' + customFilterId]
      if (filterSection && filterSection[0])
      {
        const filterEl = filterSection[0].$el
        filterEl.innerHTML = ''
        filterEl.classList.remove('d-inline-block')
        filterEl.style.display = 'none'
        filtersAPI.delete(customFilterId).catch((error) =>
        {
          console.error(error)
        })
      }
    },
    clearCustomFilter(customFilter)
    {
      this.customFiltersStatuses = []
      this.enabledCustomFilter = null
      this.$store.dispatch('filters/removeEnabledCustomFilter', customFilter)
    },
    setDefaultValues()
    {
      this.$store.dispatch('filters/setDefaultValues')
    }
  }
}
